function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleLaterTimesButton = function SvgScheduleLaterTimesButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.25,
    style: {
      fill: "#4287c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.68 14.78 4.2-4.2a.25.25 0 1 0-.36-.36l-4 4-4-4a.25.25 0 0 0-.52.18.25.25 0 0 0 .07.18l4.2 4.2a.25.25 0 0 0 .41 0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z",
    style: {
      fill: "none"
    }
  }))));
};
export default SvgScheduleLaterTimesButton;